import Query from '../../components/Report';

export const query = ({ offset = 0, domain, avgctr }) =>
    new Query('discover-recommendations-low-ctr', { offset, domain, avgctr });

export const query_get_average = new Query('discover-recommendations-low-ctr-avg');
